import { useTenant } from '@providers/Tenant';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { VersionsService } from '../api/versionsService';

export function useInstructionVersion(instructionId?: string, versionId?: string) {
  const { accountId } = useTenant();
  const service = useMemo(() => new VersionsService(), []);

  return useQuery({
    queryKey: [instructionQueryKeys.getInstructionVersion, instructionId, versionId],
    queryFn: () => service.get(accountId, instructionId!, versionId!),
    enabled: instructionId != null && versionId != null,
    refetchOnMount: true,
  });
}
